<template>
  <div>
    <div>
      <dot v-if="dot" :msg="message" :line="lineNum" @isDot="isDot" />
      <div v-if="!dot" v-html="message" />
    </div>
    <div v-if="moreThanOne && expandLink" class="u-fg--red-brand u-txt--base u-mrgn-top--3 link">
      <span v-if="manyText && dot" @click="changeState"> {{ moreText }} </span>
      <span v-if="!dot" @click="changeState">{{ lessText }}</span>
    </div>
  </div>
</template>

<script>
import dot from './Dot';

export default {
  components: { dot },
  props: {
    lineNum: {
      type: Number,
      default: 2,
    },
    message: {
      type: String,
      default: '',
    },
    moreText: {
      type: String,
      default: 'Lebih Banyak',
    },
    lessText: {
      type: String,
      default: 'Lebih Sedikit',
    },
    expandLink: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      manyText: false,
      dot: true,
    };
  },
  computed: {
    moreThanOne() {
      return this.lineNum > 1;
    },
  },
  methods: {
    changeState() {
      this.dot = !this.dot;
    },
    isDot() {
      this.manyText = true;
    },
  },
};
</script>

<style scoped>
.link {
  cursor: pointer;
}
</style>
